{
  "w": 44,
  "h": 30,
  "rows": [
    "............................................",
    ".............WWWWWWWWWWWWWWWWWW.............",
    "...........K.BBBBCCCCKKCCCCBBBB.K...........",
    "...........KBBBBWWCCCKKCCCWWBBBBK...........",
    "...........KBBBCCCCCCKKCCCCCCBBBK...........",
    "...........KBBBCCCCCCKKCCCCCCBBBK...........",
    "..........BKBBCCCCCCCKKCCCCCCCBBKB..........",
    ".........BBKBCCCCCCCCKKCCCCCCCCBKBB.........",
    ".........BBKBCCCCCCCCKKCCCCCCCCBKBB.........",
    "........BBBKcccccccccKKcccccccccKBBB........",
    ".......BBBBKcccccccccKKcccccccccKBBBB.......",
    ".......BBBBKcccccccccKKcccccccccKBBBB.......",
    "......BBKKKKKKKKKKKKKKKKKKKKKKKKKKKKBB......",
    ".....BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB.....",
    ".....BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB.....",
    "....BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB....",
    "...BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB...",
    "..BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB..",
    "..BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB..",
    ".BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB.",
    "BBKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKBB",
    "BBBBbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbBBBB",
    "BBBBbbbbbbbbbbbbbbbbbKKbbbbbbbbbbbbbbbbbBBBB",
    "BBKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKBB",
    "RRKBbbbbbbbbbbbbbbbbbKKbbbbbbbbbbbbbbbbbBKRR",
    "RRBBbbbbbbbbbbbbbbbWWWWWWbbbbbbbbbbbbbbbBBRR",
    "BBBBKKKKKKKbbbbbbbbbbbbbbbbbbbbbbKKKKKKKBBBB",
    "KKWKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKWKK",
    "....KKKKKK........................KKKKKK....",
    "............................................"
  ],
  "legend": {
    "K": "C.BLACK",
    "B": "C.B_BLUE",
    "b": "C.BLUE",
    "C": "C.B_CYAN",
    "c": "C.CYAN",
    "W": "C.B_WHITE",
    "R": "C.RED"
  }
}
